import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * config/platform.publicProfileDomain (T138 (1), Prompt #591), or null when the
 * doc/field is missing or the read fails. Callers hide the applicant-profile
 * link on null (fail closed).
 */
export async function fetchPublicProfileDomain() {
  try {
    const snap = await getDoc(doc(db, 'config', 'platform'));
    const value = snap.exists() ? snap.data()?.publicProfileDomain : null;
    return typeof value === 'string' && value.trim() ? value.trim() : null;
  } catch (err) {
    console.error('fetchPublicProfileDomain:', err);
    return null;
  }
}
